@use '@lib/assets/styles/main.scss' as *;

.contentWrap {
  position: relative;
}

.content {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  & > * {
    max-width: 100%;
  }
}

.gradient {
  background: linear-gradient(0deg, $gray0 0%, rgba($gray0, 0) 100%);
  height: 40px;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  pointer-events: none;
  z-index: 2;
}

.gradientGray {
  background: linear-gradient(0deg, $gray10 0%, rgba($gray10, 0) 100%);
}

.gradientError {
  background: linear-gradient(0deg, $error100 0%, rgba($error100, 0) 100%);
}

.gradientWarning {
  background: linear-gradient(0deg, $warning100 0%, rgba($warning100, 0) 100%);
}

.toggleButton {
  margin-top: 2px;
}
